/**
 * Application configuration
 * Environment variables are injected at build time via Webpack
 */

// Environment
export const IS_DEVELOPMENT = process.env.NODE_ENV === "development";
export const IS_PRODUCTION = process.env.NODE_ENV === "production";

// Debug mode - can be overridden via env variable
export const DEBUG_MODE = 
  process.env.REACT_APP_DEBUG_MODE === "true" || IS_DEVELOPMENT;

// API base URL - empty string means same origin (current Symfony setup)
// For standalone deployment, set REACT_APP_API_URL to the API server URL
export const API_BASE_URL = process.env.REACT_APP_API_URL || "";

// Auth endpoints
export const AUTH_LOGIN_URL = `${API_BASE_URL}/auth/login`;
export const AUTH_REFRESH_URL = `${API_BASE_URL}/auth/refresh`;
export const AUTH_REVOKE_URL = `${API_BASE_URL}/auth/revoke`;

export default {
  IS_DEVELOPMENT,
  IS_PRODUCTION,
  DEBUG_MODE,
  API_BASE_URL,
  AUTH_LOGIN_URL,
  AUTH_REFRESH_URL,
  AUTH_REVOKE_URL,
};
